module.exports = __webpack_public_path__ + "img/12.1cd970d7.png";